import { token } from '@/infrastructure/container';
import { type IAppBus } from './AppBus';
import { type ILogger } from './Logger';

export interface IDomNavigation {
  replace(path: string): void;
  push(path: string): void;
  get path(): string;
  start(): void;
}

export const TOKEN_IDomNavigation = token<IDomNavigation>('IDomNavigation');

export class DomNavigation implements IDomNavigation {
  private started = false;

  constructor(
    private bus: IAppBus,
    private logger: ILogger,
  ) {}

  start(): void {
    if (this.started) return;
    this.started = true;
    window.addEventListener('popstate', () => {
      this.bus.urlChanged(this.path);
    });
    this.logger.info('DomNavigation started at', this.path);
    this.bus.urlChanged(this.path);
  }

  replace(path: string): void {
    this.logger.debug('nav.replace', path);
    history.replaceState(null, '', path);
    this.bus.urlChanged(path);
  }

  push(path: string): void {
    this.logger.debug('nav.push', path);
    history.pushState(null, '', path);
    this.bus.urlChanged(path);
  }

  get path(): string {
    return window.location.pathname + window.location.search;
  }
}
